<div class="flex flex-col overflow-hidden h-full p-4 gap-3">
  <h2 class="text-xl font-semibold">Inputs</h2>
  @if (store.isLoading()) {
    <p-progressSpinner ariaLabel="loading" class="center-flex" />
  } @else {
    <div class="overflow-auto flex flex-col gap-3">
      @for (value of store.enteredDataValues(); track $index) {
        <div class="flex justify-between">
          <div class="inline-block input-key">{{ value.dataEntryCategoryName }}</div>
          <div class="inline-block input-value">{{ getEnteredValue(value) }}</div>
        </div>
      } @empty {
        <div class="empty-data">
          <h3 class="title">No Data yet</h3>
          <span>Once a challenge is selected, you will see data here</span>
        </div>
      }
    </div>
  }
</div>
